export class JsonEntityOpfsStorage {
    //@internal
    opfsRoot;
    async getItem(entityDbName) {
        if (!this.opfsRoot) {
            this.opfsRoot = await navigator.storage.getDirectory();
        }
        const opfsFile = await this.opfsRoot.getFileHandle(entityDbName + '.json', {
            create: true,
        });
        const readable = await opfsFile.getFile();
        return await readable.text();
    }
    async setItem(entityDbName, json) {
        const opfsFile = await this.opfsRoot.getFileHandle(entityDbName + '.json', {
            create: true,
        });
        const writable = await opfsFile.createWritable();
        await writable.write(json);
        await writable.close();
    }
}
